import { render, staticRenderFns } from "./video-element.vue?vue&type=template&id=2655ed0c&scoped=true&"
import script from "./video-element.vue?vue&type=script&lang=js&"
export * from "./video-element.vue?vue&type=script&lang=js&"
import style0 from "./video-element.vue?vue&type=style&index=0&id=2655ed0c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655ed0c",
  null
  
)

export default component.exports